var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.fileOriginalName,
          expression: "fileOriginalName",
        },
      ],
      staticClass: "form-control",
      attrs: {
        placeholder: _vm.fileOriginalName ? "" : "No files selected",
        type: "text",
        maxlength: "1024",
      },
      domProps: { value: _vm.fileOriginalName },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.fileOriginalName = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _vm.fileOriginalName
      ? _c(
          "button",
          {
            staticClass: "btn btn-sm btn-secondary",
            attrs: { type: "button" },
            on: { click: _vm.downloadFile },
          },
          [_c("i", { staticClass: "fa fa-download" }), _vm._v(" Download\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-secondary",
        attrs: { type: "button" },
        on: { click: _vm.chooseFile },
      },
      [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Upload\n  ")]
    ),
    _vm._v(" "),
    _vm.uploadPercentage > 0 && _vm.uploadPercentage < 100
      ? _c("span", [
          _vm._v("uploading... " + _vm._s(_vm.uploadPercentage) + "%"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      ref: "fileInput",
      staticStyle: { display: "none" },
      attrs: { type: "file" },
      on: { change: _vm.fileSelected },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }